var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.5625C6.6225 9.5625 4.6875 7.6275 4.6875 5.25C4.6875 2.8725 6.6225 0.9375 9 0.9375C11.3775 0.9375 13.3125 2.8725 13.3125 5.25C13.3125 7.6275 11.3775 9.5625 9 9.5625ZM9 2.0625C7.245 2.0625 5.8125 3.495 5.8125 5.25C5.8125 7.005 7.245 8.4375 9 8.4375C10.755 8.4375 12.1875 7.005 12.1875 5.25C12.1875 3.495 10.755 2.0625 9 2.0625Z",
    fill: "#574476"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55859 17.0625C2.25109 17.0625 1.99609 16.8075 1.99609 16.5C1.99609 13.2975 5.13861 10.6875 9.00111 10.6875C9.30861 10.6875 9.56361 10.9425 9.56361 11.25C9.56361 11.5575 9.30861 11.8125 9.00111 11.8125C5.76111 11.8125 3.12109 13.9125 3.12109 16.5C3.12109 16.8075 2.86609 17.0625 2.55859 17.0625Z",
    fill: "#574476"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.65 16.6125C12.015 16.6125 10.6875 15.285 10.6875 13.65C10.6875 12.015 12.015 10.6875 13.65 10.6875C15.285 10.6875 16.6125 12.015 16.6125 13.65C16.6125 15.285 15.285 16.6125 13.65 16.6125ZM13.65 11.8125C12.6375 11.8125 11.8125 12.6375 11.8125 13.65C11.8125 14.6625 12.6375 15.4875 13.65 15.4875C14.6625 15.4875 15.4875 14.6625 15.4875 13.65C15.4875 12.6375 14.6625 11.8125 13.65 11.8125Z",
    fill: "#574476"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4981 17.0626C16.3556 17.0626 16.2131 17.0101 16.1006 16.8976L15.3506 16.1476C15.1331 15.9301 15.1331 15.5701 15.3506 15.3526C15.5681 15.1351 15.9282 15.1351 16.1457 15.3526L16.8957 16.1026C17.1132 16.3201 17.1132 16.6801 16.8957 16.8976C16.7832 17.0101 16.6406 17.0626 16.4981 17.0626Z",
    fill: "#574476"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchCustomer);
export default __webpack_public_path__ + "static/media/searchCustomer.168797d3a633e245655cb17068237e85.svg";
export { ForwardRef as ReactComponent };